import type { OvercallingCurationRecord } from '../../types/overcallingDataEditing';

interface StateLabelProps {
  curation: OvercallingCurationRecord | null | undefined;
}

// "Added" (green) or "Deleted" (red) label shown next to the Overcalling — Data
// editing header for curated items. Nothing for uncurated items (FR-032..34).
export function StateLabel({ curation }: StateLabelProps) {
  if (!curation) return null;

  if (curation.isDeleted) {
    return (
      <span className="inline-block px-2 py-0.5 text-sm font-semibold text-red-700 bg-red-100 rounded">
        Deleted
      </span>
    );
  }

  return (
    <span className="inline-block px-2 py-0.5 text-sm font-semibold text-green-700 bg-green-100 rounded">
      Added
    </span>
  );
}
